import { RootState } from 'Utils/store/store';

import { IState } from '../types/SliceState';

type State = RootState & IState;

export const getMessage = (state: State) => state.notificationReducer.message;
export const getType = (state: State) => state.notificationReducer.type;
